module.exports = __webpack_public_path__ + "img/img_2.4037c136.png";